// ============================================
// SECTION — Hero
// ============================================

import {
  RiCalendarLine,
  RiArrowRightLine,
  RiShieldStarLine,
  RiGroupLine,
  RiBarChart2Line,
  RiHomeLine,
} from "react-icons/ri";
import { useInView } from "../hooks/useInView";
import "./Hero.css";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const STRIP = [
  { icon: <RiShieldStarLine />, label: "Practitioner + Researcher" },
  { icon: <RiGroupLine />, label: "Workshops + Training" },
  { icon: <RiBarChart2Line />, label: "Program Evaluation + Data" },
  { icon: <RiHomeLine />, label: "Reentry + Family Support" },
];

export default function Hero() {
  const [ref, visible] = useInView(0.05);

  return (
    <section id="hero" className="hero">
      {/* Background elements */}
      <div className="hero__bg-grid" />
      <div className="hero__bg-orb hero__bg-orb--1" />
      <div className="hero__bg-orb hero__bg-orb--2" />

      {/* Content */}
      <div
        ref={ref}
        className={`hero__content ${visible ? "hero__content--visible" : ""}`}
      >
        <span className="hero__eyebrow">Justice · Research · Impact</span>

        <h1 className="hero__title">
          Research-Informed Support for{" "}
          <em className="hero__accent">Justice-Involved</em> Individuals,
          Families &amp; Agencies.
        </h1>

        <p className="hero__sub">
          Individuals involved in the criminal justice system frequently face
          reentry without the family support and structure needed to succeed,
          leading to continued cycles of recidivism. By combining data driven
          research with practitioner insight, we help organizations implement
          solutions that create lasting change.
        </p>

        <div className="hero__btns">
          <button
            className="btn-primary hero__btn-main"
            href="https://cal.com/schea91/introcall"
                  onClick={() =>
                    window.open("https://cal.com/schea91/introcall", "_blank")
                  }
          >
            <RiCalendarLine />
            Book a Consultation
          </button>
          <button className="btn-outline" onClick={() => scrollTo("services")}>
            View Services
            <RiArrowRightLine />
          </button>
        </div>

        {/* Credibility strip */}
        <div className="hero__strip">
          {STRIP.map(({ icon, label }) => (
            <div className="hero__strip-item" key={label}>
              <span className="hero__strip-icon">{icon}</span>
              {label}
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator — clickable, smooth scrolls to next section */}
      <button
        type="button"
        className="hero__scroll-hint"
        onClick={() => scrollTo("services")}
        aria-label="Scroll to next section"
      >
        <span />
      </button>
    </section>
  );
}
